export const APPEARANCE_KEY = 'audio-editor-appearance';
const modes = ['system', 'light', 'dark'];
let preference = 'system';
let media;
let initialized = false;

function storedPreference() {
  try {
    const value = window.localStorage.getItem(APPEARANCE_KEY);
    return modes.includes(value) ? value : 'system';
  } catch { return 'system'; }
}

function apply() {
  const theme = preference === 'system' ? (media?.matches ? 'dark' : 'light') : preference;
  document.documentElement.dataset.theme = theme;
  document.documentElement.dataset.appearance = preference;
  document.documentElement.style.colorScheme = theme;
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', theme === 'dark' ? '#1d1d1f' : '#ffffff');
  document.querySelector('meta[name="color-scheme"]')?.setAttribute('content', theme);
  for (const picker of document.querySelectorAll('[data-appearance-picker]')) picker.value = preference;
  window.dispatchEvent(new Event('appearancechange'));
}

export function getAppearance() { return preference; }

export function setAppearance(value) {
  if (!modes.includes(value)) return;
  preference = value;
  try { window.localStorage.setItem(APPEARANCE_KEY, value); } catch { /* Still usable without storage. */ }
  apply();
}

export function initAppearance() {
  if (initialized) return;
  initialized = true;
  preference = storedPreference();
  media = window.matchMedia?.('(prefers-color-scheme: dark)');
  const onSystemChange = () => { if (preference === 'system') apply(); };
  if (media?.addEventListener) media.addEventListener('change', onSystemChange);
  else media?.addListener?.(onSystemChange);
  document.addEventListener('change', event => {
    if (event.target.matches?.('[data-appearance-picker]')) setAppearance(event.target.value);
  });
  window.addEventListener('storage', event => {
    if (event.key === APPEARANCE_KEY || event.key === null) {
      preference = storedPreference();
      apply();
    }
  });
  apply();
}

export function appearancePicker() {
  return `<label class="ae-appearance">Appearance
    <select aria-label="Appearance" data-appearance-picker>
      ${modes.map(mode => `<option value="${mode}" ${mode === preference ? 'selected' : ''}>${mode[0].toUpperCase() + mode.slice(1)}</option>`).join('')}
    </select>
  </label>`;
}
